export { default as canvasSlideRenderer } from "./renderers/canvasSlideRenderer";
export { default as pngBlobSlideRenderer } from "./renderers/pngBlobSlideRenderer";
export type { default as SlideRenderer } from "./SlideRenderer";
